import { gql } from "@apollo/client";

export const ODOO_ACCOUNTING_FORECAST = gql`
  query ODOO_ACCOUNTING_FORECAST($company: String!, $refresh: Boolean) {
    odooAccountingForecast(company: $company, refresh: $refresh)
  }
`;
